import { Muffe } from '../../../types/network';
import { useNetworkElementsStore } from '../../../store/networkElementsStore';
import { useStressTestStore } from '../../../store/stressTestStore';
import { useViewMode } from '../../../context/useViewMode';
import { ConnectedAbgangsleitungen } from '../ConnectedAbgangsleitungen';
import { detailStyles, headerColors } from '../../../styles/detailStyles';

interface MuffeDetailsProps {
  element: Muffe;
}

export const MuffeDetails = ({ element: initialElement }: MuffeDetailsProps) => {
  const viewMode = useViewMode();
  const isStressTestMode = viewMode === 'stress-test';

  // In stress-test mode, use isolated stress elements; otherwise use global store
  const stressElements = useStressTestStore(state => state.stressElements);
  const globalElement = useNetworkElementsStore(state =>
    state.elements.find(el => el.id === initialElement.id)
  ) as Muffe;
  const element = isStressTestMode
    ? (stressElements.find(el => el.id === initialElement.id) as Muffe)
    : globalElement;

  if (!element) {
    console.error('[MuffeDetails] Element not found in store:', initialElement.id);
    return null;
  }

  return (
    <div className={detailStyles.layout.section}>
      {/* Purple Header */}
      <div className={`${detailStyles.header.wrapper} ${headerColors.muffe.bg}`}>
        <div className={detailStyles.header.content}>
          <div className="flex items-center space-x-3">
            <div className={detailStyles.header.iconBox}>
              <svg className={`${detailStyles.header.icon} ${headerColors.muffe.icon}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
              </svg>
            </div>
            <div>
              <h2 className={detailStyles.header.title}>Muffe</h2>
              <p className={detailStyles.header.subtitle}>{element.name}</p>
            </div>
          </div>
        </div>
        <div className={`${detailStyles.header.id} ${headerColors.muffe.id}`}>ID: {element.id}</div>
      </div>

      <ConnectedAbgangsleitungen elementId={element.id} />
    </div>
  );
};
